import { useState } from "react";
import { Dialog, Popover } from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export default function Header(props) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className={`${props.bgColor} z-40`}>
      <nav
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <a href="home" className="-m-1.5 p-1.5">
            <img className="h-10 w-auto" src={props.logo} alt="" />
          </a>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <Popover.Group className="hidden lg:flex lg:gap-x-12">
          <a
            href="features"
            className="text-sm font-semibold leading-6 text-gray-500 duration-500 hover:text-white"
          >
            Features
          </a>
          <a
            href="Menu"
            className="text-sm font-semibold leading-6 text-gray-500 duration-500 hover:text-white"
          >
            Sidebar
          </a>
          <a
            href="company"
            className="text-sm font-semibold leading-6 text-gray-500 duration-500 hover:text-white"
          >
            Company
          </a>
        </Popover.Group>
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <a
            href="href"
            className="text-sm font-semibold leading-6 text-gray-500"
          >
            Contact Me <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <a href="href" className="-m-1.5 p-1.5">
              <span className="sr-only">Your Company</span>
              <img
                className="h-8 w-auto"
                src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <a
                  href="href"
                  className="-mx-3 block rounded-3xl px-3 py-2 text-base font-semibold leading-7 text-gray-200 hover:bg-gray-50"
                >
                  Features
                </a>
                <a
                  href="Menu"
                  className="-mx-3 block rounded-3xl px-3 py-2 text-base font-semibold leading-7 text-gray-200 hover:bg-gray-50"
                >
                  Sidebar
                </a>
                <a
                  href="company"
                  className="-mx-3 block rounded-3xl px-3 py-2 text-base font-semibold leading-7 text-gray-200 hover:bg-gray-50"
                >
                  Company
                </a>
              </div>
              <div className="py-6">
                <a
                  href="href"
                  className="-mx-3 block rounded-3xl px-3 py-2.5 text-base font-semibold leading-7 text-gray-200 hover:bg-gray-50"
                >
                  Contact Me
                </a>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
}
